// 问题类型映射
export const questionTypeMap = [
  [1, '导师服务'],
  [2, '预约相关'],
  [3, 'ZOOM使用'],
  [4, '平台使用'],
  [5, '产品相关'],
  [6, 'Other']
]

// 时区映射
export const zoneEnMap = [
  {
    value: 'AEST',
    title: 'Australian Eastern Standard Time'
  },
  {
    value: 'ACST',
    title: 'Australian Central Standard Time'
  },
  {
    value: 'AWST',
    title: 'Australian Central Western Standard Time'
  },
  {
    value: 'BJT',
    title: 'Beijing Time'
  },
  {
    value: 'EST',
    title: 'US Eastern Time'
  },
  {
    value: 'MST',
    title: 'US Mountain Time'
  },
  {
    value: 'CST',
    title: 'US Central Time'
  },
  {
    value: 'PST',
    title: 'US Pacific Time'
  },
  {
    value: 'SAST',
    title: 'South Africa Time'
  },
  {
    value: 'BST',
    title: 'British Time'
  },
  {
    value: 'FST',
    title: 'French Time'
  },
  {
    value: 'TST',
    title: 'Thailand Time'
  }
]
// COACH ---- 模块6, lONG_TERM
// ESSAY_CHATS----模块1-3,
// FAO_ESSAY_CHATS-----模块1-3
// FAO_COACH----模块7
// lONG_TERM---长线服务包
export const packageModuleMap = [
  ['MODULE_1', 'Module 1  Kickoff+Activity List Guidance'],
  ['MODULE_2', 'Module 2  PS Brainstorming'],
  ['MODULE_3', 'Module 3  Supplemental Easays Brainstorming'],
  ['MODULE_6', 'Module 6  Comprehensive Support (CS) Hours'],
  ['MODULE_7', 'FAO Mock Review'],
  ['LONG_TERM', 'Long-term Planning Module']
]
